import { render, staticRenderFns } from "./ShippingScale.vue?vue&type=template&id=fad77374&scoped=true&"
import script from "./ShippingScale.vue?vue&type=script&lang=js&"
export * from "./ShippingScale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad77374",
  null
  
)

export default component.exports